import eventTypeMapData from './constants/event-type-map.json'

const eventTypeById: Record<string, string> = eventTypeMapData.eventTypeById ?? {}
const eventDescByEventId: Record<string, string> = eventTypeMapData.eventDescByEventId ?? {}
// const guidByEventId: Record<string, string> = eventTypeMapData.guidByEventId ?? {}
// const eventIdByGuid: Record<string, string> = eventTypeMapData.eventIdByGuid ?? {}

function sortNumericKeys (keys: string[]): string[] {
  return [...keys].sort((a, b) => {
    const na = Number(a)
    const nb = Number(b)
    if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb
    return a.localeCompare(b)
  })
}

/** 事件类型 Id（筛选 event_type）→ 展示名称 */
export function getEventTypeName (typeId?: string | number | null): string | undefined {
  if (typeId == null || typeId === '') return undefined
  return eventTypeById[String(typeId)]
}

/** 事件 event_id → 事件描述（Excel 描述列） */
export function getEventDescByEventId (eventId?: string | number | null): string | undefined {
  if (eventId == null || eventId === '') return undefined
  return eventDescByEventId[String(eventId)]
}

/** @deprecated 使用 getEventDescByEventId */
export function getEventNameByEventId (eventId?: string | number | null): string | undefined {
  return getEventDescByEventId(eventId)
}

/**
 * 列表/详情事件类型展示：仅按 event_type Id 映射
 */
export function resolveSecurityEventTypeLabel (
  eventType?: string | number | null,
  _eventId?: string | number | null,
): string | undefined {
  return getEventTypeName(eventType)
}

/** 搜索筛选「事件类型」下拉选项（来自 Excel 事件类型Id） */
export function getEventTypeFilterOptions () {
  return sortNumericKeys(Object.keys(eventTypeById)).map((id) => ({
    label: eventTypeById[id],
    value: id,
  }))
}

/** 事件 event_id → 天翼云SDK GUID */
// export function getGuidByEventId (eventId?: string | number | null): string | undefined {
//   if (eventId == null || eventId === '') return undefined
//   return guidByEventId[String(eventId)]
// }

// /** 天翼云SDK GUID → 事件 event_id */
// export function getEventIdByGuid (guid?: string | null): string | undefined {
//   if (guid == null || guid === '') return undefined
//   return eventIdByGuid[guid]
// }

/** 事件 event_id → 完整事件信息（event_type, guid, desc） */
export function getEventInfoById (eventId?: string | number | null): {
  event_type: number
  guid: string | null
  desc: string | null
} | undefined {
  if (eventId == null || eventId === '') return undefined
  const eventsById: Record<string, { event_type: number; guid: string | null; desc: string | null }> =
    (eventTypeMapData as any).eventsById ?? {}
  return eventsById[String(eventId)]
}
